module.exports = __webpack_public_path__ + "static/media/iaturnfight.b06e19de.png";